import { observer } from "mobx-react-lite";
import {
  Checkbox,
  TableCell,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "ui";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";
import {
  type LogCellProps,
  useWorkoutItemSave,
} from "src/workouts/WorkoutItemSetContext.shared";
import { useWorkoutPermissions } from "src/workouts/WorkoutItemsPermission";
import { SET_BODY_CELL } from "src/workouts/workoutSetCells";

export const LogBodyCell = observer(function LogBodyCell(props: LogCellProps) {
  const workoutEditStore = useWorkoutEditStore();
  const workoutPermissions = useWorkoutPermissions();
  const requestSave = useWorkoutItemSave();
  const set = workoutEditStore.getSetById(props.setId);

  if (!workoutPermissions.canLogSets) {
    return (
      <TableCell className={SET_BODY_CELL}>
        <div className="flex justify-center px-2">
          <Checkbox checked={set.completed} disabled />
        </div>
      </TableCell>
    );
  }

  return (
    <TableCell className={SET_BODY_CELL}>
      <div className="flex justify-center px-2">
        <Tooltip>
          <TooltipTrigger asChild>
            <Checkbox
              checked={set.completed}
              onCheckedChange={() => {
                workoutEditStore.toggleCompleteSet(props.setId);
                requestSave();
              }}
            ></Checkbox>
          </TooltipTrigger>
          <TooltipContent>Change assigned values</TooltipContent>
        </Tooltip>
      </div>
    </TableCell>
  );
});
